module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0007.jpg?v=edb98395";